import { isPreviewableText } from '../api/storageBoxApi';
import {
  parseDocumentPageSettingsFromHtml,
  wrapHtmlWithDocumentPageSettings,
} from '../../layout/ReusableComponent/Text-editor/textEditorDocumentPageSettings';

export function isStorageBoxHtmlFile(mime, name) {
  const m = (mime || '').toLowerCase();
  if (m.includes('html')) return true;
  return /\.html?$/i.test(name || '');
}

export function isStorageBoxEditableTextFile(item) {
  return item?.type === 'file' && isPreviewableText(item.mimeType, item.name);
}

/** @returns {'rich' | 'plain'} */
export function storageBoxTextEditorKind(item) {
  if (!item) return 'plain';
  return isStorageBoxHtmlFile(item.mimeType, item.name) ? 'rich' : 'plain';
}

export function textPayloadFromLoadedContent(text, kind) {
  const body = text || '';
  if (kind === 'rich') {
    const { bodyHtml, documentPageSettings } = parseDocumentPageSettingsFromHtml(body);
    return {
      html: bodyHtml,
      markdown: '',
      mode: 'rich',
      documentPageSettings,
    };
  }
  return { html: '', markdown: body, mode: 'markdown', documentPageSettings: null };
}

export function serializeEditorPayloadForSave(payload, kind) {
  if (kind === 'rich') {
    const html = payload?.html || '';
    return wrapHtmlWithDocumentPageSettings(html, payload?.documentPageSettings);
  }
  return payload?.markdown || '';
}
